import { OmProductCard } from '@om/component-library-react';
import { graphql } from 'gatsby';
import React from 'react';
import { ThemeContext } from '../context/ThemeContext';
import './YoutubeCard.scss';

const YoutubeCard = ({ youtubeCardContent }) => {
    const theme = React.useContext(ThemeContext);

    if (!youtubeCardContent) {
        return ' ';
    }

    const { videoUrl, productCardHeader, productCardCopy } = youtubeCardContent;

    return (
        <div className={`${theme} youtube-card-wrapper`}>
            <OmProductCard>
                <span name="product-image" slot="product-image">
                    <iframe
                        src={videoUrl}
                        frameBorder="0"
                        allow="autoplay; encrypted-media; fullscreen"
                        title="video"
                    />
                </span>

                <span slot="category">Video</span>
                <span slot="product-title">{productCardHeader}</span>
                <span slot="product-copy">{productCardCopy}</span>
            </OmProductCard>
        </div>
    );
};

export const pageQuery = graphql`
    fragment YoutubeCard on Contentstack_youtube_card {
        video_copy
        video_header
        video_url
    }
`;

export default YoutubeCard;
